import Client from './client';

export class AuthApi {
    static async loginGoogle(code) {
        return Client.post('/auth/google', { code });
    }
}
